// src/pages/Workers/Documents/ExportCompanyDocumentsExcel.js
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

const ExportCompanyDocumentsExcel = async (data) => {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Company Documents");

  worksheet.columns = [
    { header: "ID", key: "id", width: 8 },
    { header: "Document Name", key: "documentName", width: 30 },
    { header: "Description", key: "description", width: 30 },
    { header: "Subject", key: "subject", width: 25 },
    { header: "File Type", key: "fileType", width: 15 },
    { header: "Status", key: "status", width: 15 },
    { header: "Uploaded At", key: "date", width: 22 },
  ];

  worksheet.addRows(data);

  worksheet.getRow(1).eachCell((cell) => {
    cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
    cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "003149" } };
    cell.alignment = { vertical: "middle", horizontal: "center" };
    cell.border = { top: { style: "thin" }, left: { style: "thin" }, bottom: { style: "thin" }, right: { style: "thin" } };
  });

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
  saveAs(blob, `Company_Documents_Report_${new Date().toISOString().slice(0, 10)}.xlsx`);
};

export default ExportCompanyDocumentsExcel;
